
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_3e226_66",
  "button": "awsui_button_vjswe_3e226_70",
  "variant-normal": "awsui_variant-normal_vjswe_3e226_132",
  "disabled": "awsui_disabled_vjswe_3e226_146",
  "grouped": "awsui_grouped_vjswe_3e226_152",
  "variant-primary": "awsui_variant-primary_vjswe_3e226_165",
  "variant-link": "awsui_variant-link_vjswe_3e226_198",
  "variant-icon": "awsui_variant-icon_vjswe_3e226_231",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_3e226_264",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_3e226_297",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_3e226_330",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_3e226_367",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_3e226_400",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_3e226_433",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_3e226_471",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_3e226_508",
  "full-width": "awsui_full-width_vjswe_3e226_511",
  "button-compact": "awsui_button-compact_vjswe_3e226_525",
  "icon-left": "awsui_icon-left_vjswe_3e226_535",
  "icon-right": "awsui_icon-right_vjswe_3e226_540",
  "button-no-text": "awsui_button-no-text_vjswe_3e226_553",
  "icon": "awsui_icon_vjswe_3e226_535",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vjswe_3e226_638",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vjswe_3e226_642",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vjswe_3e226_648",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vjswe_3e226_652",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vjswe_3e226_656",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vjswe_3e226_662",
  "grouped-with-action": "awsui_grouped-with-action_vjswe_3e226_666",
  "link": "awsui_link_vjswe_3e226_677",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_3e226_677"
};
  